<template>
    <b-modal
        id="module-access-add-las-main-groups"
        :title="$t('modules.add_main_groups')"
        modal-class="apprentice-default-modal"
        hide-footer>
        <design-2021-apprentice-data-table
            :fields="fields"
            :items="lasMainGroupsIn">
            <template v-slot:cell(actions)="data">
                <div class="actions">
                    <b-button
                        class="btn-add btn-add-module-access-las-main"
                        v-b-tooltip.hover
                        variant="primary-icon-only"
                        @click="addLasMainGroup(data.item.id)"
                        :title="$t('management.add_las_main_groups')">
                    </b-button>
                </div>
            </template>
        </design-2021-apprentice-data-table>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-module-management-edit-access-las-main-modal-component',
    props: {
        lasMainGroupsIn: Array,
        moduleIn: Object,
    },
    data() {
        return {
            fields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                    sortable: true,
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },
    methods: {
        addLasMainGroup(id) {
            let data = {
                module_id: this.moduleIn.id,
                las_main_group_id: id,
            };

            this.alert.saving();

            this.axios.post(this.routes.moduleLasMainGroupAdd(), data).then(
                (response) => {
                    this.moduleIn.addRelation('las_main_groups', response.data);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
.actions {
    display: flex;

    .btn:not(:last-child) {
        margin-right: map-get($grid-gutter-spacing, 'eight');
    }
}
</style>
